<app-header></app-header>
<a id="leftnav" class="vcal-btn"><span>Menu</span></a>
<app-leftsidebar [activePath]="activePath"></app-leftsidebar>

<div class="cp-main-sec mp-main">
  @if (!pack) {
    <section class="mp-card">
      <div class="mp-heading">
        <h2>Map packs</h2>
        <button class="btn btn-dark" type="button" (click)="showNew = !showNew">
          {{ showNew ? 'Cancel' : 'Make a pack' }}
        </button>
      </div>
      <p class="mp-lead">
        Map packs change how markers look on your maps: inns, ruins, lairs and the rest. A pack only
        changes your own view; the game master still decides what is on the map.
      </p>

      @if (showNew) {
        <form class="mp-form" (ngSubmit)="createPack()">
          <label>Name <input name="name" [(ngModel)]="newPack.name" required maxlength="120" /></label>
          <label>Description <textarea name="description" [(ngModel)]="newPack.description" rows="3"></textarea></label>
          <label class="mp-check"><input type="checkbox" name="free" [(ngModel)]="newPack.isFree" /> Free for everyone</label>
          @if (!newPack.isFree) {
            <label>Price (USD) <input name="price" type="number" min="0.5" step="0.01" [(ngModel)]="newPack.price" /></label>
          }
          <button class="btn btn-green" type="submit" [disabled]="busy || !newPack.name.trim()">Create pack</button>
        </form>
      }

      <h3>Applied to your maps</h3>
      @if (loading) {
        <p class="mp-muted">Loading…</p>
      } @else if (!applied.length) {
        <p class="mp-muted">None yet. Your maps use the standard WorldTumbler markers.</p>
      } @else {
        <ol class="mp-applied">
          @for (p of applied; track p.slug; let first = $first; let last = $last) {
            <li>
              <span class="mp-name">{{ p.name }}</span>
              @if (first && applied.length > 1) { <span class="mp-tag">Used first</span> }
              <span class="mp-spacer"></span>
              <button type="button" class="mp-icon-btn" [disabled]="first" (click)="move(p, -1)" aria-label="Use earlier">▲</button>
              <button type="button" class="mp-icon-btn" [disabled]="last" (click)="move(p, 1)" aria-label="Use later">▼</button>
              <button type="button" class="btn btn-dark btn-sm" (click)="toggleApply(p)">Remove</button>
            </li>
          }
        </ol>
      }

      <h3>Your packs</h3>
      @if (!loading && !owned.length) {
        <p class="mp-muted">You have no map packs yet. Find them in the store, or make your own.</p>
      }
      <div class="mp-grid">
        @for (p of owned; track p.slug) {
          <div class="mp-pack">
            <div class="mp-name">{{ p.name }}</div>
            <div class="mp-muted">
              {{ p.mine ? 'Made by you' : p.is_free ? 'Free' : 'Bought' }} · {{ p.art_count }} pictures
              @if (p.mine) { · {{ statusText[p.status] || p.status }} }
            </div>
            @if (p.description) { <p class="mp-desc">{{ p.description }}</p> }
            <div class="mp-actions">
              <button type="button" class="btn btn-sm" [class.btn-green]="!p.applied" [class.btn-dark]="p.applied" (click)="toggleApply(p)">
                {{ p.applied ? 'Remove from my maps' : 'Use on my maps' }}
              </button>
              @if (p.mine) {
                <a class="btn btn-dark btn-sm" [routerLink]="['/map-packs', p.slug]">Edit</a>
              }
            </div>
          </div>
        }
      </div>

      @if (reviewQueue !== null) {
        <h3>Waiting for review</h3>
        @if (!reviewQueue.length) {
          <p class="mp-muted">Nothing to review.</p>
        }
        @for (p of reviewQueue; track p.slug) {
          <div class="mp-review">
            <div><span class="mp-name">{{ p.name }}</span> <span class="mp-muted">by {{ p.creator }} · {{ p.art_count }} pictures</span></div>
            <input #reviewNote placeholder="Note to the creator (optional)" />
            <button type="button" class="btn btn-green btn-sm" (click)="decide(p, true, reviewNote.value)">Approve</button>
            <button type="button" class="btn btn-dark btn-sm" (click)="decide(p, false, reviewNote.value)">Send back</button>
          </div>
        }
      }
    </section>
  } @else {
    <section class="mp-card">
      <div class="mp-heading">
        <h2>{{ pack.name }}</h2>
        <a class="btn btn-dark" routerLink="/map-packs">Back</a>
      </div>
      <p class="mp-status" [attr.data-status]="pack.status">
        {{ statusText[pack.status] || pack.status }}
        @if (pack.review_note) { — {{ pack.review_note }} }
      </p>

      <form class="mp-form" (ngSubmit)="saveDetails()">
        <label>Name <input name="ename" [(ngModel)]="edit.name" maxlength="120" /></label>
        <label>Description <textarea name="edesc" [(ngModel)]="edit.description" rows="3"></textarea></label>
        <label class="mp-check"><input type="checkbox" name="efree" [(ngModel)]="edit.isFree" /> Free for everyone</label>
        @if (!edit.isFree) {
          <label>Price (USD) <input name="eprice" type="number" min="0.5" step="0.01" [(ngModel)]="edit.price" /></label>
        }
        <div class="mp-actions">
          <button class="btn btn-dark btn-sm" type="submit" [disabled]="busy">Save details</button>
          <button class="btn btn-green btn-sm" type="button" (click)="submit()" [disabled]="busy || pack.status === 'in_review'">
            {{ pack.status === 'approved' ? 'Published' : 'Submit for publishing' }}
          </button>
        </div>
      </form>

      <div class="mp-tools">
        <label class="btn btn-dark btn-sm mp-file">Import a zip
          <input type="file" accept=".zip" (change)="importZip($event)" />
        </label>
        <button type="button" class="btn btn-dark btn-sm" (click)="exportZip()">Export as zip</button>
        <span class="mp-muted mp-hint">Zip layout: <code>inn.svg</code> for an inn, <code>inn&#64;size=large.png</code> for large inns.</span>
      </div>

      <p class="mp-muted">
        Pictures: SVG, or PNG at 64×80 or 128×160 for pins (48×48 or 96×96 for round glyphs). Slots without a
        picture use the standard marker, shown faded.
      </p>

      @for (g of slotGroups; track g.category) {
        <h3>{{ categoryNames[g.category] }}</h3>
        <div class="mp-slots">
          @for (s of g.slots; track s.type) {
            <div class="mp-slot" [class.is-empty]="s.falls_back">
              <div class="mp-slot-pics">
                @if (s.art.length) {
                  @for (a of s.art; track a.id) {
                    <figure>
                      <img [src]="serviceurl + a.url" [alt]="s.name" />
                      <figcaption>{{ variantLabel(a.variant) }}
                        <button type="button" class="mp-x" (click)="removeArt(a)" aria-label="Remove picture">×</button>
                      </figcaption>
                    </figure>
                  }
                } @else if (s.standard_pin || s.standard_glyph) {
                  <figure class="mp-standard"><img [src]="lib + (s.standard_pin || s.standard_glyph)" [alt]="s.name" /><figcaption>Standard</figcaption></figure>
                }
              </div>
              <div class="mp-slot-name">{{ s.name }} @if (s.new) { <span class="mp-tag">New</span> }</div>
              <label class="mp-file mp-link">{{ s.art.length ? 'Replace' : 'Add picture' }}
                <input type="file" accept=".svg,.png" (change)="upload(s, $event)" />
              </label>
              <input class="mp-variant" [(ngModel)]="variantFor[s.type]" placeholder="variant, e.g. size=large" [name]="'v-' + s.type" />
              @if (variantFor[s.type]) {
                <label class="mp-file mp-link">Add for this variant
                  <input type="file" accept=".svg,.png" (change)="upload(s, $event, true)" />
                </label>
              }
            </div>
          }
        </div>
      }

      <h3>Add a new marker type</h3>
      <form class="mp-form mp-inline" (ngSubmit)="addType()">
        <input name="tkey" [(ngModel)]="newType.key" placeholder="key, e.g. wyvern-roost" />
        <input name="tname" [(ngModel)]="newType.name" placeholder="name, e.g. Wyvern roost" />
        <select name="tcat" [(ngModel)]="newType.category">
          @for (c of categoryNames | keyvalue; track c.key) { <option [value]="c.key">{{ c.value }}</option> }
        </select>
        <button class="btn btn-dark btn-sm" type="submit" [disabled]="!newType.key.trim()">Add type</button>
      </form>

      <div class="mp-danger">
        @if (!confirmDelete) {
          <button type="button" class="btn btn-danger btn-sm" (click)="confirmDelete = true">Delete pack</button>
        } @else {
          <span>Delete this pack and its pictures?</span>
          <button type="button" class="btn btn-danger btn-sm" (click)="deletePack()">Yes, delete</button>
          <button type="button" class="btn btn-dark btn-sm" (click)="confirmDelete = false">Keep it</button>
        }
      </div>
    </section>
  }
</div>
